<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm_title"><a id="page_vii"></a>Abbreviations</h2>
<table>
<tbody><tr>
<td class="tab1">AFSA</td>
<td class="tab2">Armed Forces Security Agency</td>
</tr>
<tr>
<td class="tab1">AGI</td>
<td class="tab2">Auxiliary Vessel, Intelligence Gatherer</td>
</tr>
<tr>
<td class="tab1">AI</td>
<td class="tab2">Air Intelligence</td>
</tr>
<tr>
<td class="tab1">ASA</td>
<td class="tab2">Army Security Agency</td>
</tr>
<tr>
<td class="tab1">BEF</td>
<td class="tab2">British Expeditionary Force</td>
</tr>
<tr>
<td class="tab1">BRUSA</td>
<td class="tab2">Britain – United States of America Security Pact</td>
</tr>
<tr>
<td class="tab1">CBME</td>
<td class="tab2">Combined Bureau Middle East</td>
</tr>
<tr>
<td class="tab1">CIA</td>
<td class="tab2">American Central Intelligence Agency</td>
</tr>
<tr>
<td class="tab1">CID</td>
<td class="tab2">Committee of Imperial Defence</td>
</tr>
<tr>
<td class="tab1">CSDIC</td>
<td class="tab2">Combined Services Detailed Interrogation Centre</td>
</tr>
<tr>
<td class="tab1">CSE</td>
<td class="tab2">Canadian Communications Security Establishment</td>
</tr>
<tr>
<td class="tab1">DF</td>
<td class="tab2">Direction-finding</td>
</tr>
<tr>
<td class="tab1">DMI</td>
<td class="tab2">Director of Military Intelligence</td>
</tr>
<tr>
<td class="tab1">DNI</td>
<td class="tab2">Director of Naval Intelligence</td>
</tr>
<tr>
<td class="tab1">DSD</td>
<td class="tab2">Australian Defence Signals Directorate</td>
</tr>
<tr>
<td class="tab1">DWS</td>
<td class="tab2">Diplomatic Wireless Service</td>
</tr>
<tr>
<td class="tab1">FBI</td>
<td class="tab2">American Federal Bureau of Investigation</td>
</tr>
<tr>
<td class="tab1">FECB</td>
<td class="tab2">Far East Combined Bureau</td>
</tr>
<tr>
<td class="tab1">GC&amp;CS</td>
<td class="tab2">Government Code and Cypher School</td>
</tr>
<tr>
<td class="tab1">GCHQ</td>
<td class="tab2">Government Communications Headquarters</td>
</tr>
<tr>
<td class="tab1">GPO</td>
<td class="tab2">General Post Office</td>
</tr>
<tr>
<td class="tab1">HDU</td>
<td class="tab2">Home Defence Unit</td>
</tr>
<tr>
<td class="tab1">KGB</td>
<td class="tab2">Soviet Committee for State Security</td>
</tr>
<tr>
<td class="tab1">MI1</td>
<td class="tab2">Directorate of Military Intelligence</td>
</tr>
<tr>
<td class="tab1">MI5</td>
<td class="tab2">British Security Service</td>
</tr>
<tr>
<td class="tab1">MI6</td>
<td class="tab2">British Secret Intelligence Service</td>
</tr>
<tr>
<td class="tab1">MI8</td>
<td class="tab2">British Radio Security Service</td>
</tr>
<tr>
<td class="tab1">MI9</td>
<td class="tab2">British Escape and Evasion Service</td>
</tr>
<tr>
<td class="tab1">NATO</td>
<td class="tab2">North Atlantic Treaty Organisation</td>
</tr>
<tr>
<td class="tab1">NID</td>
<td class="tab2">Naval Intelligence Division</td>
</tr>
<tr>
<td class="tab1"><a id="page_viii"></a>NKVD</td>
<td class="tab2">Soviet Intelligence Service</td>
</tr>
<tr>
<td class="tab1">NSA</td>
<td class="tab2">American National Security Agency</td>
</tr>
<tr>
<td class="tab1">NZCSB</td>
<td class="tab2">New Zealand Communications Security Bureau</td>
</tr>
<tr>
<td class="tab1">OSS</td>
<td class="tab2">Office of Strategic Services</td>
</tr>
<tr>
<td class="tab1">PCO</td>
<td class="tab2">Passport Control Officer</td>
</tr>
<tr>
<td class="tab1">RSGB</td>
<td class="tab2">Radio Society of Great Britain</td>
</tr>
<tr>
<td class="tab1">RSS</td>
<td class="tab2">Radio Security Service</td>
</tr>
<tr>
<td class="tab1">SCU</td>
<td class="tab2">Special Communications Unit</td>
</tr>
<tr>
<td class="tab1">SD</td>
<td class="tab2">Nazi Security Service</td>
</tr>
<tr>
<td class="tab1">SIS</td>
<td class="tab2">American Signal Intelligence Service</td>
</tr>
<tr>
<td class="tab1">SLO</td>
<td class="tab2">Security Liaison Officer</td>
</tr>
<tr>
<td class="tab1">SLU</td>
<td class="tab2">Special Liaison Unit</td>
</tr>
<tr>
<td class="tab1">SOE</td>
<td class="tab2">Special Operations Executive</td>
</tr>
<tr>
<td class="tab1">SWG</td>
<td class="tab2">Special Wireless Group</td>
</tr>
<tr>
<td class="tab1">UKUSA</td>
<td class="tab2">United Kingdom – United States of America Security Agreement</td>
</tr>
<tr>
<td class="tab1">VI</td>
<td class="tab2">Voluntary Interceptor</td>
</tr>
<tr>
<td class="tab1">Y</td>
<td class="tab2">Wireless Interception</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?6ed2360e